import { graphql } from "gatsby";
import Image from "gatsby-image";
import parse from "html-react-parser";
import PropTypes from "prop-types";
import React from "react";

import "./faq.scss";

import BreadCrumb from "../../components/BreadCrumb/breadCrumb";
import ContactSupport from "../../components/ContactSupport/contactSupport";
import FeedbackSurvey from "../../components/FeedbackSurvey/feedbackSurvey";
import Header from "../../components/Header/header";
import PageList from "../../components/PageList/pageList";
import SideNavbar from "../../components/SideNavbar/sideNavbar";
import VerticalLine from "../../components/VerticalLine/verticalLine";

import { isTokenPresent } from "../../utils/cookieHelper";
import { getCTAType } from "../../utils/helperFunctions";
import contentParserOptions from "../../utils/parser";

const Faq = ({
  data: {
    wpPage: {
      uri = "",
      featuredImage = {},
      content = "",
    } = {},
  },
  pageContext: { allPagesData = {} },
}) => {
  const {
    feedbackSurvey = false,
    "related-queries": relatedQueries = [],
    title = "",
    ctaDetails = [],
  } = allPagesData[uri] || {};
  const ctaType = getCTAType(ctaDetails);
  const isContactSupportCTA = ctaType === "contact-support";
  return (
    <>
      <Header />
      <BreadCrumb uri={uri} allPagesData={allPagesData} />
      <div className="faq-grid">
        <SideNavbar uri={uri} allPagesData={allPagesData} />
        <VerticalLine />
        <div className="faq-page">
          <div className="faq-page-div">
            <div className="faq-title">{title}</div>
            <div className="faq-featured-image">
              <Image
                fluid={
                  featuredImage?.node?.localFile
                    ?.childImageSharp?.fluid
                }
                alt={"Page Featured Image"}
              />
            </div>
            <div className="faq-content">
              {content &&
                parse(content, contentParserOptions)}
            </div>
            {isContactSupportCTA && isTokenPresent() && (
              <ContactSupport />
            )}
            {feedbackSurvey && <FeedbackSurvey />}
          </div>
          <PageList
            allPagesData={allPagesData}
            pages={relatedQueries}
            heading="Related Queries"
            showIcon={false}
          />
        </div>
      </div>
    </>
  );
};

Faq.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
};

export default Faq;

export const query = graphql`
  query FaqPageById($id: String!) {
    wpPage(id: { eq: $id }) {
      uri
      content
      featuredImage {
        node {
          localFile {
            childImageSharp {
              fluid {
                srcSet
              }
            }
          }
        }
      }
    }
  }
`;
